<template>
  <div class="expense-table-component">
    <b-card class="formCard">
      <b-card-text>
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="mb-0"><b-badge variant="info">Nature Of Expense Charges Details</b-badge></h5>
          <div class="d-flex align-items-center">
             <model-list-select
              :list="natureOfExpenseOptions"
              v-model="customExpense.nature_name"
              option-value="nature_name"
              option-text="nature_name"
              placeholder="Select Nature of Expense"
              class="expense-select-dropdown"
              ref="natureExpenseSelect"
            />
            <!-- <b-form-input
              v-model="customExpense.nature_name"
              placeholder="Enter custom expense name"
              size="sm"
              style="width: 250px; margin-right: 10px;"
              @keyup.enter="addCustomExpense"
            ></b-form-input> -->
            <b-button variant="primary" size="sm" @click="addCustomExpense" :disabled="isLoading || !customExpense.nature_name.trim()">
              <md-icon>add</md-icon> Add
            </b-button>
          </div>
        </div>

        <div class="table-responsive">
          <table v-if="natureOfExpense && natureOfExpense.length > 0" class="table table-sm table-bordered table-striped expense-table">
            <thead class="thead-light">
              <tr>
                <th style="min-width: 10px">SN</th>
                <th style="min-width: 200px">Nature of Expense</th>
                <th style="min-width: 120px">Expense Incurred</th>
                <th style="min-width: 160px">Upload Invoice</th>
                <th style="min-width: 130px">Amount to Pay</th>
                <th style="min-width: 120px">Bill to Shipper</th>
                <th style="min-width: 130px">Amount to Bill</th>
                <th style="min-width: 140px">Bill to Type</th>
                <th style="min-width: 80px">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in natureOfExpense" :key="`expense-row-${index}`" class="expense-row">
                <!-- SN -->
                <td class="text-center">{{ index + 1 }}</td>
                
                <!-- Nature of Expense -->
                <td>
                  <div>
                    {{ item.nature_name }}
                    <b-badge v-if="item.isCustom" variant="info" size="sm" class="ml-1">Custom</b-badge>
                  </div>
                </td>
                
                <!-- Expense Incurred -->
                <td>
                  <div v-if="item.expenseIncurred">
                    <b-form-radio-group v-model="item.expenseIncurred"
                      @input="onExpenseIncurredChange(index, $event)"
                      :options="yesNoOptions" :name="'expenseIncurred_' + index" buttons button-variant="outline-primary"
                      size="sm"></b-form-radio-group>
                  </div>
                  <div v-else>
                    <small class="text-muted">Select Yes/No</small>
                    <b-form-radio-group v-model="item.expenseIncurred"
                      @input="onExpenseIncurredChange(index, $event)"
                      :options="yesNoOptions" :name="'expenseIncurred_' + index" buttons button-variant="outline-primary"
                      size="sm"></b-form-radio-group>
                  </div>
                  <div v-if="getFieldValidationMessage(index, 'expenseIncurred')" class="text-danger small mt-1">
                    <i class="fa fa-exclamation-triangle mr-1"></i>
                    {{ getFieldValidationMessage(index, 'expenseIncurred') }}
                  </div>
                </td>
                
                <!-- Upload Invoice -->
                <td>
                  <div v-if="item.expenseIncurred === 'Yes'">
                    <!-- Show upload input only if no document link exists -->
                    <div v-if="!item.invoiceFile">
                      <SingleUpload
                        :index="index"
                        :assign_no="jobNo || item.job_type || ''"
                        :documentName="'Expense_' + (item.nature_name || 'Unknown')"
                        :fileAllModuleId="allModuleId || ''"
                        @fileuploaded="handleFileUploaded"
                        @fileuploadedindex="handleFileUploadedIndex"
                      />
                    </div>
                    
                    <!-- Show document links if document already exists -->
                    <div v-if="item.invoiceFile" class="mt-1">
                      <a 
                        href="#" 
                        @click.prevent="viewDocument(getFileName(item.invoiceFile), allModuleId, jobNo || item.job_type)"
                        class="text-primary mr-2 small"
                        style="text-decoration: underline; font-size: 12px;"
                      >
                        <i class="fa fa-eye mr-1"></i>View
                      </a>
                      <a 
                        href="#" 
                        @click.prevent="downloadDocument(getFileName(item.invoiceFile), allModuleId, jobNo || item.job_type)"
                        class="text-success small"
                        style="text-decoration: underline; font-size: 12px;"
                      >
                        <i class="fa fa-download mr-1"></i>Download
                      </a>
                    </div>
                    
                    <div v-if="getFieldValidationMessage(index, 'invoiceFile')" class="text-danger small mt-1">
                      <i class="fa fa-exclamation-triangle mr-1"></i>
                      {{ getFieldValidationMessage(index, 'invoiceFile') }}
                    </div>
                  </div>
                  <span v-else class="text-muted">-</span>
                </td>
                
                <!-- Amount to Pay -->
                <td>
                  <div>
                    <b-form-input v-if="item.expenseIncurred === 'Yes'" v-model="item.amountToBePaid"
                      type="number" step="0.01" placeholder="Amount" size="sm" style="min-width: 120px;"
                      @input="clearValidationMessage(index, 'amountToBePaid')"></b-form-input>
                    <span v-else class="text-muted">-</span>
                    <div v-if="getFieldValidationMessage(index, 'amountToBePaid')" class="text-danger small mt-1">
                      <i class="fa fa-exclamation-triangle mr-1"></i>
                      {{ getFieldValidationMessage(index, 'amountToBePaid') }}
                    </div>
                  </div>
                </td>
                
                <!-- Bill to Shipper -->
                <td>
                  <div v-if="item.billToShipper">
                    <b-form-radio-group v-model="item.billToShipper"
                      @input="onBillToShipperChange(index, $event)"
                      :options="yesNoOptions" :name="'billToShipper_' + index" buttons button-variant="outline-success"
                      size="sm"></b-form-radio-group>
                  </div>
                  <div v-else>
                    <small class="text-muted">Select Yes/No</small>
                    <b-form-radio-group v-model="item.billToShipper"
                      @input="onBillToShipperChange(index, $event)"
                      :options="yesNoOptions" :name="'billToShipper_' + index" buttons button-variant="outline-success"
                      size="sm"></b-form-radio-group>
                  </div>
                  <div v-if="getFieldValidationMessage(index, 'billToShipper')" class="text-danger small mt-1">
                    <i class="fa fa-exclamation-triangle mr-1"></i>
                    {{ getFieldValidationMessage(index, 'billToShipper') }}
                  </div>
                </td>
                
                <!-- Amount to Bill -->
                <td>
                  <div>
                    <b-form-input v-if="item.billToShipper === 'Yes'" v-model="item.amountToBeBilled"
                      type="number" step="0.01" placeholder="Amount" size="sm" style="min-width: 120px;"
                      @input="clearValidationMessage(index, 'amountToBeBilled')"></b-form-input>
                    <span v-else class="text-muted">-</span>
                    <div v-if="getFieldValidationMessage(index, 'amountToBeBilled')" class="text-danger small mt-1">
                      <i class="fa fa-exclamation-triangle mr-1"></i>
                      {{ getFieldValidationMessage(index, 'amountToBeBilled') }}
                    </div>
                  </div>
                </td>
                
                <!-- Bill to Type -->
                <td>
                  <div>
                    <model-list-select v-if="item.billToShipper === 'Yes'" :list="billToOptions"
                      v-model="item.billToType"
                      option-value="value" option-text="text" placeholder="Select"
                      style="min-width: 140px;"></model-list-select>
                    <span v-else class="text-muted">-</span>
                    <div v-if="getFieldValidationMessage(index, 'billToShipper')" class="text-danger small mt-1">
                      <i class="fa fa-exclamation-triangle mr-1"></i>
                      {{ getFieldValidationMessage(index, 'billToType') }}
                    </div>
                  </div>
                </td>
                
                <!-- Actions -->
                <td class="text-center">
                  <b-button v-if="item.isCustom" variant="outline-danger" size="sm" @click="removeRow(index)">
                    <md-icon>delete</md-icon>
                  </b-button>
                </td>
              </tr>
                      </tbody>
          </table>
          <div v-else-if="natureOfExpense && natureOfExpense.length === 0" class="text-center p-4">
            <p class="text-muted">No expenses added yet.</p>
          </div>
          <div v-else class="text-center p-4">
            <b-spinner small class="mr-2"></b-spinner>
            Loading expense options...
          </div>
        </div>



        <div v-if="natureOfExpense && natureOfExpense.length > 0" class="mt-3">
          <small class="text-muted">
            Total Expenses: {{ natureOfExpense.length }} |
            Total Amount to Pay: ${{ totalAmountToPay.toFixed(2) }} |
            Total Amount to Bill: ${{ totalAmountToBill.toFixed(2) }}
          </small>
        </div>

        <!-- Debug Info (remove in production) -->
        <div v-if="showDebug" class="mt-4">
          <h6>Debug Info:</h6>
          <pre>{{ JSON.stringify(natureOfExpense, null, 2) }}</pre>
        </div>

      </b-card-text>
    </b-card>

    <md-dialog-confirm :md-content-html="alert.content || ' '" :md-ok-text="alert.ok" ref="addPop">
    </md-dialog-confirm>
  </div>
</template>

<script>
  import { ModelListSelect } from "vue-search-select";
  import NodeLockPannelService from "../../services/NodeLockPannelService.js";
  import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
  import SingleUpload from "./singleUpload.vue";
  import { getJobNatureOfExpenseList } from "../../helper/collection";
export default {
  name: "ExpenseTableComponent",
  components: {
    ModelListSelect,
    SingleUpload,
  },
  props: {
    invoiceStatus: {
      type: String,
      default: "1", // 1 = In-Progress, 0 = Closed
    },

    showDebug: {
      type: Boolean,
      default: false,
    },


    allModuleId: {
      type: String,
      default: "",
    },
    jobNo: {
      type: String,
      default: "",
    },
    moduleType: {
      type: String,
      default: "",
    },
    transportType: {
      type: String,
      default: "",
    },
    branchId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      docURL: URL_BASE_DOC,
      uploadedFileData: null, // Store uploaded file data
      isLoading: false,
      isSubmited: false,
      is_noe_validation: false,
      yesNoOptions: [
        { text: "Yes", value: "Yes" },
        { text: "No", value: "No" },
        { text: "Inprogress", value: "Inprogress" },
      ],
      billToOptions: [
        { text: "Bill to Shipper", value: "shipper" },
        { text: "Bill to Agent", value: "agent" },
        { text: "Bill to Consignee", value: "consignee" },
        { text: "Bill to Forwarder", value: "forwarder" },
      ],
      natureOfExpenseOptions: [],
      natureOfExpense: [],
      alert: {
        content: " ",
        ok: "OK",
      },
      validationMessages: [],
      fieldValidationMessages: {},
      customExpense: {
        nature_name: "",
      },

    };
  },
  computed: {
    totalAmountToPay() {
      if (!this.natureOfExpense || !Array.isArray(this.natureOfExpense)) return 0;
      return this.natureOfExpense.reduce((total, row) => {
        const amount = parseFloat(row.amountToBePaid) || 0;
        return total + (row.expenseIncurred === 'Yes' ? amount : 0);
      }, 0);
    },
    totalAmountToBill() {
      if (!this.natureOfExpense || !Array.isArray(this.natureOfExpense)) return 0;
      return this.natureOfExpense.reduce((total, row) => {
        const amount = parseFloat(row.amountToBeBilled) || 0;
        return total + (row.billToShipper === 'Yes' ? amount : 0);
      }, 0);
    },


  },
  beforeMount() {
    this.getAllNatureOfExpense();
  },
  watch: {
    allModuleId: {
      handler(newVal) {
        if (newVal && newVal.toString().trim() !== "") {
          this.getJobNatureOfExpenseList();
        }
      },
      immediate: true
    }
  },
  mounted() {
    // Ensure alert is properly initialized
    if (!this.alert.content) {
      this.alert.content = " ";
    }
    // Listen to file upload events from SingleUpload component
    global.eventBus.$on("fileuploaded", this.handleFileUploaded);
    global.eventBus.$on("fileuploadedindex", this.handleFileUploadedIndex);
  },
  beforeDestroy() {
    // Clean up event listeners
    global.eventBus.$off("fileuploaded", this.handleFileUploaded);
    global.eventBus.$off("fileuploadedindex", this.handleFileUploadedIndex);
  },
  methods: {
    
    getFieldValidationMessage(rowIndex, fieldName) {
      const key = `${rowIndex}_${fieldName}`;
      return this.fieldValidationMessages[key] || null;
    },

    getAllNatureOfExpense() {
      let payload = { isSelectedColumn: 1, isAll: 1 };
      NodeLockPannelService.getNatureOfExpense(payload)
        .then((response) => {
          const { data, status } = response;
          if (status == 200 && data && data.data.length > 0) {
            this.natureOfExpenseOptions = data.data;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isSubmited = false;
          console.log("Catch on getNatureOfExpense Error: ", error);
        });
    },
    getJobNatureOfExpenseList() {
      this.is_noe_validation = false; // Reset to false initially
      let payload = { module_id: this.allModuleId, jobNo: this.jobNo, moduleType: this.moduleType, transportType: this.transportType, branchId: this.branchId };
      
      getJobNatureOfExpenseList(payload, (error, result) => {
        if (error) {
          console.log("Catch on getNatureOfExpense Error: ", error);
          this.isSubmited = false;
        } else {
          if (result && result.natureOfExpense) {
            this.natureOfExpense = result.natureOfExpense;
            this.is_noe_validation = result.is_noe_validation;
            // Also populate natureOfExpenseOptions for the dropdown
            this.natureOfExpenseOptions = [...this.natureOfExpense];
          }
        }
        this.isLoading = false;
      });
    },
    handleFileUploaded(fileData) {
      // Store the uploaded file data for use in other handlers
      this.uploadedFileData = fileData;
    },
    handleFileUploadedIndex(index) {
      // Update the invoiceFile for the specific row with the actual file data
      if (this.natureOfExpense[index] && this.uploadedFileData) {
        // Set the invoiceFile to the uploaded file data
        this.$set(this.natureOfExpense[index], 'invoiceFile', this.uploadedFileData);
        // Force update to refresh the UI
        this.$forceUpdate();
      }
    },

    // Method to clear validation message for a specific field
    clearValidationMessage(rowIndex, fieldName) {
      const key = `${rowIndex}_${fieldName}`;
      if (this.fieldValidationMessages[key]) {
        this.$set(this.fieldValidationMessages, key, null);
      }
    },
    
    removeRow(index) {
      // Only custom expenses can be removed
      const expense = this.natureOfExpense[index];
      if (expense && expense.isCustom) {
        this.natureOfExpense.splice(index, 1);
        this.alert.content = `Custom expense "${expense.nature_name}" removed successfully!`;
        this.$refs["addPop"].open();
      }
    },
    onExpenseIncurredChange(index, value) {
      // Clear validation message for expenseIncurred
      const validationKey = `${index}_expenseIncurred`;
      if (this.fieldValidationMessages[validationKey]) {
        this.$set(this.fieldValidationMessages, validationKey, null);
      }

      if (value === "No") {
        this.natureOfExpense[index].invoiceFile = null;
        this.natureOfExpense[index].amountToBePaid = "";
        
        // Automatically set Bill to Shipper to "No" when Expense Incurred is "No"
        this.natureOfExpense[index].billToShipper = "No";
        this.natureOfExpense[index].amountToBeBilled = "";
        this.natureOfExpense[index].billToType = "";
        
        // Clear related validation messages
        if (this.fieldValidationMessages[`${index}_invoiceFile`]) {
          this.$set(this.fieldValidationMessages, `${index}_invoiceFile`, null);
        }
        if (this.fieldValidationMessages[`${index}_amountToBePaid`]) {
          this.$set(this.fieldValidationMessages, `${index}_amountToBePaid`, null);
        }
        if (this.fieldValidationMessages[`${index}_billToShipper`]) {
          this.$set(this.fieldValidationMessages, `${index}_billToShipper`, null);
        }
        if (this.fieldValidationMessages[`${index}_amountToBeBilled`]) {
          this.$set(this.fieldValidationMessages, `${index}_amountToBeBilled`, null);
        }
        if (this.fieldValidationMessages[`${index}_billToType`]) {
          this.$set(this.fieldValidationMessages, `${index}_billToType`, null);
        }
      }
    },
    onBillToShipperChange(index, value) {
      // Clear validation message for billToShipper
      const validationKey = `${index}_billToShipper`;
      if (this.fieldValidationMessages[validationKey]) {
        this.$set(this.fieldValidationMessages, validationKey, null);
      }

      if (value === "No") {
        this.natureOfExpense[index].amountToBeBilled = "";
        this.natureOfExpense[index].billToType = "";
        
        // Clear related validation messages
        if (this.fieldValidationMessages[`${index}_amountToBeBilled`]) {
          this.$set(this.fieldValidationMessages, `${index}_amountToBeBilled`, null);
        }
        if (this.fieldValidationMessages[`${index}_billToType`]) {
          this.$set(this.fieldValidationMessages, `${index}_billToType`, null);
        }
      }
    },

    validateExpenses() {
      // Skip validation if parent/flags allow it
      // If invoice status is In-Progress (1) -> no validation
      if (this.invoiceStatus === '1') {
        return true;
      }

      // If overall validation flag is disabled -> no validation
      if (!this.is_noe_validation) {
        return true;
      }

      this.validationMessages = [];
      this.fieldValidationMessages = {};

      for (let i = 0; i < this.natureOfExpense.length; i++) {
        const row = this.natureOfExpense[i];
        const rowName = row.nature_name || row.text || `Row ${i + 1}`;

        // Validate expenseIncurred selection
        if (!row.expenseIncurred || row.expenseIncurred === "") {
          this.validationMessages.push(`Row ${i + 1} (${rowName}): Please select Yes/No for Expense Incurred`);
          this.fieldValidationMessages[`${i}_expenseIncurred`] = "Please select Yes/No for Expense Incurred";
        }

        // Validate billToShipper selection
        if (!row.billToShipper || row.billToShipper === "") {
          this.validationMessages.push(`Row ${i + 1} (${rowName}): Please select Yes/No for Bill to Shipper`);
          this.fieldValidationMessages[`${i}_billToShipper`] = "Please select Yes/No for Bill to Shipper";
        }

        if (row.expenseIncurred === "Yes") {
          if (!row.invoiceFile) {
            this.validationMessages.push(`Row ${i + 1} (${rowName}): Please upload invoice file`);
            this.fieldValidationMessages[`${i}_invoiceFile`] = "Please upload invoice file";
          }
          if (!row.amountToBePaid) {
            this.validationMessages.push(`Row ${i + 1} (${rowName}): Please enter amount to be paid`);
            this.fieldValidationMessages[`${i}_amountToBePaid`] = "Please enter amount to be paid";
          }
        }

        if (row.billToShipper === "Yes") {
          if (!row.amountToBeBilled) {
            this.validationMessages.push(`Row ${i + 1} (${rowName}): Please enter amount to be billed`);
            this.fieldValidationMessages[`${i}_amountToBeBilled`] = "Please enter amount to be billed";
          }
          if (!row.billToType) {
            this.validationMessages.push(`Row ${i + 1} (${rowName}): Please select bill to type`);
            this.fieldValidationMessages[`${i}_billToType`] = "Please select bill to type";
          }
        }
      }

      // Emit validation status to parent
      this.$emit('expense-validation', {
        isValid: this.validationMessages.length === 0,
        messages: this.validationMessages,
        fieldErrors: this.fieldValidationMessages
      });

      if (this.validationMessages.length > 0) {
        this.alert.content = "<strong>Validation Errors:</strong><br><br>" +
          this.validationMessages.join("<br>");
        // this.$refs["addPop"].open();
        return false;
      }

      return true;
    },


    // Method to get all expenses data for parent validation (only validated ones)
    getAllExpensesData() {
      return this.natureOfExpense.filter(expense =>
        expense.expenseIncurred === 'Yes' || expense.billToShipper === 'Yes'
      );
    },

    // Method to get ALL expenses data regardless of selection (for parent to get complete data)
    getAllExpensesDataComplete() {
      return this.natureOfExpense.map(expense => {
        return {
          jnom_id: expense.jnom_id || 0,
          doc_id: expense.doc_id,
          nature_name: expense.nature_name,
          expenseIncurred: expense.expenseIncurred || "",
          invoiceFile: expense.invoiceFile || null,
          amountToBePaid: expense.amountToBePaid || "",
          billToShipper: expense.billToShipper || "",
          amountToBeBilled: expense.amountToBeBilled || "",
          billToType: expense.billToType || "",
          fk_nature_of_expense_id: expense.fk_nature_of_expense_id,
          module_id: expense.module_id,
          job_type: this.moduleType,
          module_type: this.transportType,
          branch_id: expense.branch_id,
          isCustom: expense.isCustom || false
        };
      });
    },

    // Method to validate expenses and return status (for parent to call)
    validateExpensesForParent() {
      return this.validateExpenses();
    },

    // Method to view document
    viewDocument(fileName, moduleId, jobNo) {
      if (!fileName || !moduleId) {
        this.alert.content = "Document information is missing. Cannot view document.";
        this.$refs["addPop"].open();
        return;
      }
      
      this.openSignedDocument(`ASSIGNMENT_UPLOADS/${jobNo.replaceAll('/', '_')}/${fileName}`);
    },

    // Method to download document
    downloadDocument(fileName, moduleId, jobNo) {
      if (!fileName || !moduleId) {
        this.alert.content = "Document information is missing. Cannot download document.";
        this.$refs["addPop"].open();
        return;
      }

      this.openSignedDocument(`ASSIGNMENT_UPLOADS/${jobNo.replaceAll('/', '_')}/${fileName}`);
    },

    // Helper method to get filename from different file formats
    getFileName(fileData) {
      if (typeof fileData === 'string') {
        // If it's a string (from API), return as is
        return fileData;
      } else if (fileData && fileData.name) {
        // If it's a File object, return the name
        return fileData.name;
      } else if (fileData && fileData.fileName) {
        // If it's an object with fileName property
        return fileData.fileName;
      }
      return '';
    },
    addCustomExpense() {
      if (!this.customExpense.nature_name.trim()) {
        return;
      }

      const expenseName = this.customExpense.nature_name.trim();

      // Create a new custom expense entry
      const newCustomExpense = {
        jnom_id:0,
        doc_id: null,
        nature_name: expenseName,
        expenseIncurred: "",
        invoiceFile: null,
        amountToBePaid: "",
        billToShipper: "",
        amountToBeBilled: "",
        billToType: "",
        fk_nature_of_expense_id: "",
        module_id: this.allModuleId || "",
        job_type: "",
        branch_id: this.branchId || "",
        isCustom: true, // Flag to identify custom expenses
      };

      // Add to both arrays to keep them in sync
      // this.natureOfExpenseOptions.unshift(newCustomExpense);
      this.natureOfExpense.unshift(newCustomExpense);

      // Clear the input field completely
      this.customExpense.nature_name = "";
      
      // Reset the dropdown selection by clearing the v-model
      // The model-list-select component will automatically update when v-model changes
      this.$nextTick(() => {
        // Force update to ensure the UI reflects the change
        this.$forceUpdate();
      });

      // Show success message
      this.alert.content = `Custom expense "${expenseName}" added successfully!`;
      this.$refs["addPop"].open();
    },
  },
};
</script>

<style scoped>
.expense-table-component {
  margin: 20px 0;
}

.formCard {
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.expense-table {
  font-size: 0.875rem;
}

.expense-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
  border: 1px solid #dee2e6;
}

.expense-table td {
  vertical-align: middle;
  border: 1px solid #dee2e6;
  padding: 8px;
}

.table-responsive {
  /* max-height: 1200px; */
  overflow-y: auto;
}

.d-flex {
  display: flex;
}

.justify-content-between {
  justify-content: space-between;
}

.align-items-center {
  align-items: center;
}

.text-right {
  text-align: right;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mb-0 {
  margin-bottom: 0;
}

.mb-3 {
  margin-bottom: 1rem;
}

.mt-3 {
  margin-top: 1rem;
}

.mt-4 {
  margin-top: 1.5rem;
}

.text-muted {
  color: #6c757d;
}

.text-success {
  color: #28a745;
}

pre {
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 4px;
  font-size: 12px;
}

.expense-select-dropdown {
  min-width: 250px !important;
  height: 38px !important;
  font-size: 14px !important;
}

.expense-select-dropdown .ui.search.dropdown {
  min-width: 250px !important;
  height: 38px !important;
}

.expense-select-dropdown .ui.search.dropdown .text {
  line-height: 36px !important;
  padding: 0 12px !important;
}

.expense-select-dropdown .ui.search.dropdown .menu {
  max-height: 200px !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// expenseTableComponent.vue?23c024c3